module.exports = __webpack_public_path__ + "static/media/28-3.fa22ccb5.mp3";